import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Link } from '@change/ds-core-ui/Link';
import { Form, TextField } from '@change/ds-forms';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { useLoginEmailForm } from './hooks/useLoginEmailForm';

type Props = Readonly<{
	/** Renders the step's Continue inside the form, instead of relying on the page footer's. */
	withSubmitButton?: boolean;
}>;

export const LoginEmailForm: React.FC<Props> = ({ withSubmitButton }) => {
	const {
		data: { email, emailError, identified, loading, canSubmit },
		actions: { submitStep, setStepData, changeUser },
	} = useLoginEmailForm();
	const { translate } = useI18n();

	return (
		<>
			<Form
				onSubmit={() => {
					void submitStep();
				}}
				data-testid="email-form"
				data-qa="email-form"
			>
				<TextField
					id="email"
					type="text"
					name="email"
					size="large"
					data-testid="email"
					data-qa="email"
					label={translate('corgi.login_or_signup.common.labels.email')}
					onChange={(value) => setStepData({ email: value })}
					value={email}
					isInvalid={!!emailError}
					errorMessage={emailError}
					isReadOnly={identified}
				/>
				{withSubmitButton && (
					<Button
						type="submit"
						variant="primary"
						size="large"
						className="mt-4 w-full"
						loading={loading}
						disabled={!canSubmit && !loading}
						data-testid="email-form-continue"
						data-qa="email-form-continue"
					>
						{translate('corgi.sap.button.forward')}
					</Button>
				)}
			</Form>
			{identified && (
				<div className="mt-2">
					<Link
						as="button"
						onClick={changeUser}
						data-testid="forgot-password"
						data-qa="forgot-password"
						variant="secondary"
					>
						{/* TODO rename key to non sign-specific key */}
						<Translate value="fe.components.petition_sign.not_you" />
					</Link>
				</div>
			)}
		</>
	);
};
